export default {
  aria: true,
  classNames: {},
  classes: false,
  delay: 0,
  dictionary: null,
  errorBagName: 'errors',
  events: 'input|blur',
  fieldsBagName: 'veeFields',
  i18n: null,
  i18nRootKey: 'validations',
  inject: true,
  locale: 'en',
  validity: false,
  useConstraintAttrs: true
};
